var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersummaryLuggage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7122 13.9212V4.99668C15.7122 4.62296 15.5637 4.2645 15.2995 4.00031C15.0352 3.73601 14.6767 3.58758 14.303 3.58758H11.4847V1.70877C11.4847 1.33505 11.3362 0.976585 11.072 0.71229C10.8077 0.448101 10.4493 0.299561 10.0755 0.299561H6.31783C5.94411 0.299561 5.58565 0.448092 5.32135 0.71229C5.05716 0.976588 4.90862 1.33502 4.90862 1.70877V3.58758H2.09036C1.71664 3.58758 1.35818 3.73601 1.09388 4.00031C0.829692 4.2645 0.681152 4.62296 0.681152 4.99668V13.9212C0.681152 14.2949 0.829684 14.6534 1.09388 14.9176C1.35818 15.1818 1.71661 15.3304 2.09036 15.3304H14.3028C14.6765 15.3304 15.035 15.1818 15.2993 14.9176C15.5635 14.6533 15.712 14.2949 15.712 13.9212H15.7122ZM9.60597 3.58756H6.78771V2.17837H9.60597V3.58756Z",
    fill: "#C3C6CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersummaryLuggage);
export default __webpack_public_path__ + "static/media/ordersummary_luggage.f2332934cd314926d5ddf5be98df0133.svg";
export { ForwardRef as ReactComponent };